var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-layout',{attrs:{"view":"lhh LpR lff"}},[_c('q-page-container',[_c('q-page',{attrs:{"padding":""}},[_c(_vm.dataView,{tag:"component"})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }